import { Auth } from '@aws-amplify/auth';
import Moment from 'moment';
import signOut from './Signout';

const refreshToken = async (force = false) => {
  try {
    const currentSession = await Auth.currentSession();
    const sessionIdToken = currentSession.getIdToken();
    const { exp } = sessionIdToken.payload;

    // printing expiry time on every check so we can test this
    // eslint-disable-next-line no-console
    console.log(`JWT Expiry: ${Moment(exp * 1000).toLocaleString()}`);
    if ((exp - 60) < (Moment.now() / 1000) || force) {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const token = await currentSession.getRefreshToken();
      cognitoUser.refreshSession(token, (err) => {
        if (err) signOut().catch(() => undefined);
      });
    }
  } catch {
    signOut();
  }
};

export default refreshToken;
